// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f6df3a52","466":"13b30171","620":"b6e32c7d"}[chunkId] + ".chunk.js";
};